/**
 * Pendant zu `<IwmDropdownGruppenkennzeichen @bind-Value=Model.Feld … />`. Die
 * Validierungsmeldung gibt im Altclient die Auswahlliste selbst aus (`ValidationFor`);
 * die Stelle im Markup ist dieselbe.
 */

import { GruppenkennzeichenDropdown } from '@/components/inputs/GruppenkennzeichenDropdown';
import type { EntityTypes } from '@/types/enums';

import { asText, type FieldAccess } from './fieldAccess';
import { FormField } from './FormField';

export interface GruppenkennzeichenFieldProps<T> {
  form: FieldAccess<T>;
  name: keyof T & string;
  entity: EntityTypes;
  /** Feldname der API — weicht bei `NlSp` → `NLSp` und `PoD` → `Pod` vom Modellfeld ab. */
  fieldName: string;
  /** Beschriftung über dem Feld — Text unverändert aus REQ-10 §3. */
  label: string;
}

export function GruppenkennzeichenField<T>(props: GruppenkennzeichenFieldProps<T>) {
  const { form, name } = props;
  const field = form.viewField(name);
  if (field === null) return null;

  return (
    <FormField message={form.message(name)}>
      <GruppenkennzeichenDropdown
        value={asText(form.value(name))}
        entity={props.entity}
        fieldName={props.fieldName}
        label={props.label}
        readOnly={field.ReadOnly}
        onChange={(value) => {
          form.setValue(name, value);
        }}
      />
    </FormField>
  );
}

export default GruppenkennzeichenField;
